module.exports = __webpack_public_path__ + "img/progress_018.4cc7f008.png";